import React from "react";

import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  useTheme,
} from "@mui/material";

import { focusRingSx } from "./focusRingSx";

interface DepartmentDialogProps {
  open: boolean;
  name: string;
  onNameChange: (value: string) => void;
  saving: boolean;
  error: string | null;
  onClose: () => void;
  onCreate: () => void;
}

const DepartmentDialog: React.FC<DepartmentDialogProps> = ({
  open,
  name,
  onNameChange,
  saving,
  error,
  onClose,
  onCreate,
}) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={() => !saving && onClose()}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Create Department</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {error && (
            <Alert severity="error" sx={{ borderRadius: 1 }}>
              {error}
            </Alert>
          )}
          <TextField
            label="Department Name"
            fullWidth
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="e.g. Engineering"
            disabled={saving}
            sx={focusRingSx(theme)}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          disabled={saving}
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onCreate()}
          disabled={saving || !name.trim()}
          sx={{
            textTransform: "none",
            "&:active": { transform: "scale(0.98)" },
          }}
        >
          {saving ? <CircularProgress size={18} color="inherit" /> : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DepartmentDialog;
